<template>
  <transition name="modal-fade">
    <div v-if="show" class="modal-overlay" @click.self="$emit('close')">
      <div class="modal-content">
        <button class="modal-close" @click="$emit('close')">&times;</button>

        <template v-if="article">
          <h2 class="modal-title">{{ article.title }}</h2>
          <div class="modal-meta">
            <span>发布于 {{ article.date }}</span>
            <span>分类: {{ article.category }}</span>
          </div>
          <hr class="modal-divider" />
          <div class="modal-body" v-html="article.fullContent"></div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ArticleDetailModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    article: {
      type: Object,
      default: null,
    },
  },
  emits: ['close'],
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  border-radius: 12px;
  margin-top: 5%;
  width: 90%;
  max-width: 800px;
  max-height: 80%;
  overflow-y: auto;
  padding: 40px;
  position: relative;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  color: #888;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
}
.modal-close:hover {
  color: #000;
}

.modal-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-top: 0;
  margin-bottom: 15px;
  text-align: center;
}

.modal-meta {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-bottom: 25px;
}

@media (max-width: 768px) {
  .modal-meta {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  
  .modal-meta span {
    margin: 0;
  }
}

.modal-meta span {
  margin: 0 5px;
}

.modal-divider {
  border: none;
  border-top: 1px solid #e9ecef;
  margin-bottom: 25px;
}

.modal-body {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
}
.modal-body >>> h3 { /* Style for h3 tags inside the v-html content */
  font-size: 20px;
  margin-top: 2em;
  margin-bottom: 1em;
}
.modal-body >>> p {
  margin-bottom: 1.5em;
}

/* Fade transition for the modal */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>